<template>
  <div :class="['status', type]" :style="noBorder ? style : ''">
    <div class="circle">
      <div></div>
    </div>
    <div class="textStyle">{{ text }}</div>
  </div>
</template>
<script setup>
defineProps(['type', 'noBorder', 'text'])
const style = {
  border: 'unset',
  background: 'transparent',
  'box-shadow': 'unset'
}
</script>
<style lang="less" scoped>
@flex: {
  display: flex;
  align-items: center;
  justify-content: center;
}

@font: {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  border-radius: 4px;
  letter-spacing: 0.4px;
}

// 默认inactive
.status {
  @font();
  display: inline-flex;
  padding: 4px 8px;
  color: #878394;
  align-items: center;
  background: #EBE9F0;
  border: 1px solid var(--border-1);
  box-shadow: 0 1px 0 0 var(--box-shadow-1);
  white-space: nowrap;
  border-radius: 20px;
  .circle {
    @flex();
    width: 12px;
    height: 12px;
    margin-right: 3px;
    border-radius: 50%;
    background: #DFDCE5;

    >div {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #ABA8B4;
    }
  }
}
.finished {
  color: rgba(40, 110, 250, 1);
  border: 1px solid rgba(204, 216, 255, 1);
  background: rgba(204, 216, 255, 0.3);
  .circle {
    background: rgba(80, 137, 250, 0.2);

    >div {
      background-color: rgba(80, 137, 250, 1);
    }
  }
}
.delivering {
  color: #7653DA;
  background: rgba(138, 100, 244, 0.1);
  border: 1px solid rgba(138, 100, 244, 0.4);
  // box-shadow: 0 1px 0 0 #1a16250d;

  .circle {
    background: rgba(138, 100, 244, 0.2);

    >div {
      background-color: rgba(138, 100, 244, 1);
    }
  }
}
.active {
  color: rgba(0, 153, 71, 1);
  background: #F0FDF6;
  border: 1px solid rgba(151, 211, 179, 1);
  box-shadow: 0 1px 0 0 #1a16250d;

  .circle {
    background: #C2E7D4;

    >div {
      background-color: #2AAE67;
    }
  }
}

.inactiveAuthorization {
  color: #0f0629b3;
  
  // background: #f59b001a;
  border: 1px solid  rgba(193, 191, 200, 1);
  background: #F5F6F7;
  box-shadow: 0 1px 0 0 #1a16250d;
  
  .circle {
    background: rgba(171, 168, 180, 0.2);

    >div {
      background-color: #544E67;
    }
  }
}
.inactive {
  color: rgba(135, 130, 148, 1);
  
  // background: #f59b001a;
  border: 1px solid  rgba(232, 229, 237, 1);
  background: rgba(245, 246, 247, 1);

  // .textStyle{
  //   opacity: 0.3;
  // }
  .circle {
    background: rgba(84, 78, 103, 0.2);

    >div {
      background-color: rgba(84, 78, 103, 1);
    }
  }
}
.pending {
  color: #E68200;
  background: #f59b001a;
  border: 1px solid #f59b0066;
  box-shadow: 0 1px 0 0 #1a16250d;

  .circle {
    background: rgba(245, 155, 0, 0.2);

    >div {
      background-color: #F59B00;
    }
  }
}
.not_authorized {
  color: rgba(235, 78, 61, 1);
  background: rgba(235, 78, 61, 0.2);
  border: 1px solid rgba(235, 78, 61, 0.2);
  box-shadow: 0 1px 0 0 #1a16250d;

  .circle {
    background: rgba(235, 78, 61, 0.2);

    >div {
      background-color: rgba(235, 78, 61, 1);
    }
  }
}
.authorized {
  color: #009947;
  background: #F0FDF6;
  border: 1px solid #F0FDF6;
  box-shadow: 0 1px 0 0 #1a16250d;

  .circle {
    background: #C2E7D4;

    >div {
      background-color: #2AAE67;
    }
  }
}
</style>